<template>
  <div class="hosOrder">
    <h3>
      消息详情<span @click="complain">投诉</span
      ><el-button class="btn_top" @click="open" type="primary"
        >查看详情</el-button
      >
    </h3>
    <div class="titleNav">
      <span :class="isNav ? 'on' : ''" @click="handClick(0)">订单进度</span>
      <span :class="isNav ? '' : 'on'" @click="handClick(1)">查看位置</span>
    </div>
    <div v-show="isNav">
      <div class="tail">
        <span>订单跟踪：</span>
        <div>
          <p v-if="createdTime1(expressList.orderStatus)">
            <span class="time">{{ createdTime1(expressList.orderStatus) }}</span
            ><span>{{ orderStatus1(expressList.orderStatus) }}</span>
          </p>
          <p v-if="createdTime2(expressList.orderStatus)">
            <span class="time">{{ createdTime2(expressList.orderStatus) }}</span
            ><span>{{ orderStatus2(expressList.orderStatus) }}</span>
          </p>
          <p v-if="createdTime3(expressList.orderStatus)">
            <span class="time">{{ createdTime3(expressList.orderStatus) }}</span
            ><span>{{ orderStatus3(expressList.orderStatus) }}</span>
          </p>
          <p v-if="createdTime4(expressList.orderStatus)">
            <span class="time">{{ createdTime4(expressList.orderStatus) }}</span
            ><span>{{ orderStatus4(expressList.orderStatus) }}</span>
          </p>
          <p v-if="createdTime5(expressList.orderStatus)">
            <span class="time">{{ createdTime5(expressList.orderStatus) }}</span
            ><span>{{ orderStatus5(expressList.orderStatus) }}</span>
          </p>
          <p v-if="createdTime6(expressList.orderStatus)">
            <span class="time">{{ createdTime6(expressList.orderStatus) }}</span
            ><span>{{ orderStatus6(expressList.orderStatus) }}</span>
          </p>
        </div>
      </div>
      <div class="info">
        <table>
          <tr>
            <td>寄件人姓名</td>
            <td>{{ expressList.sendName }}</td>
          </tr>
          <tr>
            <td>寄件人电话</td>
            <td>{{ expressList.sendMobile }}</td>
          </tr>
          <tr>
            <td>寄件人地址</td>
            <td>{{ expressList.sendAddress }}</td>
          </tr>
          <tr>
            <td>收件人姓名</td>
            <td>
              {{
                expressList.getName1
                  ? expressList.getName1
                  : expressList.getName
              }}
            </td>
          </tr>
          <tr>
            <td>收件人电话</td>
            <td>
              {{
                expressList.getMobile1
                  ? expressList.getMobile1
                  : expressList.getMobile
              }}
            </td>
          </tr>
          <tr>
            <td>收件人地址</td>
            <td>
              {{
                expressList.getAddress1
                  ? expressList.getAddress1
                  : expressList.getAddress
              }}
            </td>
          </tr>
          <tr v-if="expressList.getName2">
            <td>收件人姓名</td>
            <td>
              {{
                expressList.getName2
                  ? expressList.getName2
                  : expressList.getName
              }}
            </td>
          </tr>
          <tr v-if="expressList.getMobile2">
            <td>收件人电话</td>
            <td>
              {{
                expressList.getMobile2
                  ? expressList.getMobile2
                  : expressList.getMobile
              }}
            </td>
          </tr>
          <tr v-if="expressList.getAddress2">
            <td>收件人地址</td>
            <td>
              {{
                expressList.getAddress2
                  ? expressList.getAddress2
                  : expressList.getAddress
              }}
            </td>
          </tr>
          <tr v-if="expressList.getName3">
            <td>收件人姓名</td>
            <td>
              {{
                expressList.getName3
                  ? expressList.getName3
                  : expressList.getName
              }}
            </td>
          </tr>
          <tr v-if="expressList.getMobile3">
            <td>收件人电话</td>
            <td>
              {{
                expressList.getMobile3
                  ? expressList.getMobile3
                  : expressList.getMobile
              }}
            </td>
          </tr>
          <tr v-if="expressList.getAddress3">
            <td>收件人地址</td>
            <td>
              {{
                expressList.getAddress3
                  ? expressList.getAddress3
                  : expressList.getAddress
              }}
            </td>
          </tr>
          <tr>
            <td>物品名称</td>
            <td>{{ expressList.goodsName }}</td>
          </tr>
          <tr>
            <td>物品重量</td>
            <td>{{ expressList.goodsWeight }}公斤</td>
          </tr>
          <tr>
            <td>取件时间</td>
            <td>{{ expressList.getGoodsDate }}</td>
          </tr>
          <tr>
            <td>备注信息</td>
            <td>{{ expressList.description }}</td>
          </tr>
          <tr>
            <td>追加备注</td>
            <td>{{ expressList.addRemark }}</td>
          </tr>
          <tr>
            <td>退回备注</td>
            <td>{{ expressList.refundRemark }}</td>
          </tr>
          <tr>
            <td>取消备注</td>
            <td>{{ expressList.cancelReason }}</td>
          </tr>


          <tr v-if="expressList.expressType">
            <td>快递</td>
            <td>{{ expressList.expressType }}</td>
          </tr>
          <tr v-if="expressList.payMethod">
            <td>付款方式</td>
            <td>{{ expressList.payMethod }}</td>
          </tr>
        </table>
        <div class="info" v-if="expressList.isEvaluate == 1">
          <div class="info_title" style="font-size: 30px; margin: 30px 0px">
            评价
          </div>
          <table>
            <tr>
              <td>评价内容</td>
              <td>{{ expressList.evaluateContent }}</td>
            </tr>
            <tr>
              <td>评价星级</td>
              <td>
                <el-rate
                  v-model="expressList.evaluateStar"
                  disabled
                  show-score
                  text-color="#ff9900"
                >
                </el-rate>
              </td>
            </tr>
            <tr>
              <td>评价时间</td>
              <td>{{ expressList.evaluateDate }}</td>
            </tr>
          </table>
        </div>

        <div class="orderDetail">
          <div>
            <span>优惠券:</span>
            <span
              >{{ expressList.couponFee ? expressList.couponFee : 0.0 }}元</span
            >
          </div>
          <div>
            <span>服务费:</span>
            <span>{{ expressList.serverFee }}元</span>
          </div>
          <div>
            <span>加价:</span>
            <span>{{ expressList.addFee }}元</span>
          </div>
          <div>
            <span>溢价:</span>
            <span class="totalPrice">{{ expressList.premiumFee }}元</span>
          </div>
          <div class="total">
            <span>合计:</span>
            <span class="totalPrice">{{ expressList.payFee }}元</span>
          </div>
        </div>
      </div>
    </div>
    <div v-show="!isNav" class="allmap">
      <div id="allmap"></div>
    </div>

    <el-dialog
  title="提示"
  :visible.sync="dialogVisible"
  width="30%"
  :before-close="handleClose">
   <div  class="info">
       <table>
          <tr>
            <td>接单时间</td>
            <td>{{expressList.accessDate}}</td>
          </tr>
          <tr>
            <td>发货人</td>
            <td>{{expressList.sendName}}</td>
          </tr>
          <tr>
            <td>发货地址</td>
            <td>{{expressList.sendAddress}}</td>
          </tr>
          <tr>
            <td>发货号码</td>
            <td>{{expressList.sendMobile}}</td>
          </tr>
          <tr>
            <td>收件人</td>
            <td>{{expressList.goodsName}}</td>
          </tr>
          <tr>
            <td>收件地址</td>
            <td>{{expressList.getAddress1}}</td>
          </tr>
          <tr>
            <td>收件人号码</td>
            <td>{{expressList.getMobile1}}</td>
          </tr>
          <tr>
            <td>费用</td>
            <td>{{expressList.payFee}}</td>
          </tr>
          <tr>
            <td>备注信息</td>
            <td>{{expressList.description }}</td>
          </tr>
        </table>
         </div>
  <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
  </span>
</el-dialog>
  </div>
</template>

<script>
import { reqDomesticOrderDetail, reqCityOrderDetail } from "../../../api";
export default {
  data() {
    return {
      dialogVisible:false,
      expressList: {},
      isNav: true,
    };
  },
  created() {
    const { id, type } = this.$route.query;
    if (type == 1) {
      reqCityOrderDetail(id).then((res) => {
        console.log(res);
        if (res.code === 200) {
          this.expressList = res.data.bussData;
        }
      });
    }
    if (type == 2) {
      reqDomesticOrderDetail(id).then((res) => {
        console.log(res);
        if (res.code === 200) {
          this.expressList = res.data.bussData;
        }
      });
    }
  },
  methods: {
     handleClose(){
      this.dialogVisible=false
    },
    open(){
      this.dialogVisible=true
    },
    // 获取地图
    getMap(
      getLong,
      getLat,
      getAdd,
      sendLong,
      sendLat,
      sendAdd,
      longitude,
      latitude
    ) {
      // 百度地图API功能
      var map = new BMap.Map("allmap");
      map.centerAndZoom(new BMap.Point(getLong, getLat), 10);
      var navigationControl = new BMap.NavigationControl({
        // 靠左上角位置
        anchor: BMAP_ANCHOR_TOP_LEFT,
        // LARGE类型
        type: BMAP_NAVIGATION_CONTROL_LARGE,
        // 启用显示定位
        enableGeolocation: true,
      });
      // map.enableScrollWheelZoom(true);
      // theLocation()
      // 用经纬度设置地图中心点
      map.clearOverlays();
      var new_point = new BMap.Point(getLong, getLat);
      var new_point1 = new BMap.Point(sendLong, sendLat);
      var new_point2 = new BMap.Point(longitude, latitude);
      var marker = new BMap.Marker(new_point); // 创建标注
      var marker1 = new BMap.Marker(new_point1); // 创建标注
      var marker2 = new BMap.Marker(new_point2); // 创建标注
      map.addOverlay(marker); // 将标注添加到地图中
      map.addOverlay(marker1); // 将标注添加到地图中
      map.addOverlay(marker2); // 将标注添加到地图中

      let opts = {
        width: 250, // 信息窗口宽度
        height: 80, // 信息窗口高度
        title: "信息窗口", // 信息窗口标题
        enableMessage: true, //设置允许信息窗发送短息
      };
      addClickHandler(getAdd, marker);
      addClickHandler(sendAdd, marker1);
      function addClickHandler(content, marker) {
        marker.addEventListener("click", function (e) {
          openInfo(content, e);
        });
      }
      function openInfo(content, e) {
        var p = e.target;
        var point = new BMap.Point(p.getPosition().lng, p.getPosition().lat);
        var infoWindow = new BMap.InfoWindow(content, opts); // 创建信息窗口对象
        map.openInfoWindow(infoWindow, point); //开启信息窗口
      }
      map.addControl(navigationControl);
    },
    // 切换导航
    handClick(type) {
      this.isNav = type === 0 ? true : false;
      if (type === 1) {
        this.$nextTick(() => {
          this.getMap(
            this.expressList.getLongitude1,
            this.expressList.getLatitude1,
            this.expressList.getAddress1,
            this.expressList.sendLongitude,
            this.expressList.sendLatitude,
            this.expressList.sendAddress,
            this.expressList.longitude,
            this.expressList.latitude
          );
        });
      }
    },
    // 投诉
    complain() {
      const { id } = this.$route.query;
      this.$router.push({ name: "Complain", query: { id } });
    },
    createdTime1(status) {
      return this.expressList.createDate;
    },
    createdTime2(status) {
      return this.expressList.accessDate;
    },
    createdTime3(status) {
      return this.expressList.paymentDate;
    },
    createdTime4(status) {
      return this.expressList.evaluateDate;
    },
    createdTime5(status) {
      return this.expressList.finishDate;
    },
    createdTime6(status) {
      return this.expressList.cancelDate;
    },
    orderStatus1(status) {
      return "待支付";
    },
    orderStatus2(status) {
      return "待抢单";
    },
    orderStatus3(status) {
      return "进行中";
    },
    orderStatus4(status) {
      return "待评价";
    },
    orderStatus5(status) {
      return "已完成";
    },
    orderStatus6(status) {
      return "已取消";
    },
  },
};
</script>

<style scoped lang="less" type="text/less">
.btn_top{
  margin-left: 50px;
}
.hosOrder {
  h3 {
    font-size: 24px;
    margin-top: 60px;
    span {
      margin-left: 59px;
      font-size: 16px;
      color: #2fa1de;
      font-weight: bold;
      cursor: pointer;
    }
  }
  .titleNav {
    display: flex;
    margin-top: 30px;
    span {
      display: block;
      width: 100px;
      height: 40px;
      margin-right: 30px;
      font-size: 16px;
      font-weight: 500;
      line-height: 40px;
      text-align: center;
      border-radius: 20px;
      border: 1px solid rgba(153, 153, 153, 1);
      box-sizing: border-box;
      cursor: pointer;
      &.on {
        background: #61aee6;
        color: #fff;
        border: none;
      }
    }
  }
  .tail {
    margin-top: 29px;
    display: flex;
    p {
      margin-bottom: 15px;
      .time {
        display: inline-block;
        width: 180px;
        margin-right: 20px;
      }
    }
  }
  .info {
    margin-top: 40px;
    table {
      /*border:1px solid #e1e1e1;*/
      td {
        border: 1px solid #e1e1e1;
        &:first-of-type {
          width: 129px;
          height: 40px;
          line-height: 40px;
          text-indent: 20px;
        }
        &:last-of-type {
          width: 440px;
          height: 40px;
          line-height: 40px;
          padding: 0 30px;
          box-sizing: border-box;
        }
      }
    }
    .orderDetail {
      width: 569px;
      box-sizing: border-box;
      margin-top: 19px;
      padding: 30px 30px 20px;
      border: 4px solid #f1f1f1;
      div {
        display: flex;
        justify-content: space-between;
        margin-bottom: 30px;
        font-size: 16px;
        &.total {
          span {
            font-size: 20px;
            font-weight: 500;
            &:last-of-type {
              color: #e60012;
            }
          }
        }
      }
    }
  }
  /*地图大小*/

  .allmap,
  #allmap {
    margin-top: 20px;
    width: 700px;
    height: 400px;
    margin-bottom: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Person/Children/ExpressOrder.vue